import { createFileRoute } from "@tanstack/react-router";

import { PageBlocks } from "@/components/content/PageBlocks";
import { PageShell } from "@/components/layout/PageShell";
import { heroFor } from "@/data/heroes";
import { pageBlocks } from "@/lib/content";

const TITLE = "Privacy Policy — Light of Life International";
const DESCRIPTION =
  "How Light of Life International collects, uses and protects the information you share with our ministry.";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://loli.ardent.dev/privacy-policy" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://loli.ardent.dev/privacy-policy" }],
  }),
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  const blocks = pageBlocks("privacy-policy").filter((b) => b.t !== "h1");

  return (
    <PageShell title="Privacy Policy" image={heroFor("/privacy-policy").image}>
      <PageBlocks blocks={blocks} />
    </PageShell>
  );
}
